import React from 'react';
import { useInView } from 'react-intersection-observer';

import { IndexSuggestionItemsBlock } from '@components/IndexSuggestionItemsBlock';
import IndexSuggestionItemsBlockContainer from '@containers/IndexSuggestionItemsBlockContainer';

export const IndexSuggestionItemsBlockPreloaderContainer: React.FC = () => {
  const { ref, inView } = useInView({
    rootMargin: '100px',
  });

  return (
    <div ref={ref}>
      {inView ? (
        <IndexSuggestionItemsBlockContainer />
      ) : (
        <IndexSuggestionItemsBlock
          products={[]}
          loading={true}
          onLoadMore={() => undefined}
          hasNextPage={false}
        />
      )}
    </div>
  );
};
